export default {
  // OneTimeTask.vue translations
  addMember: "Add Member",
  email: "Email",
  emailExistsError:
    "This email is already registered. Please use another email.",
  generalError: "An error occurred while submitting. Please try again later.",
  invalidCompanyIdOrUserId: "Invalid Company ID or User ID.",
  oneTimeTaskDeleted: "One Time Task deleted successfully.",
  oneTimeTaskAdded: "One Time Task added successfully.",
  deleteConfirmationTitle: "Delete One Time Task",
  deleteConfirmationText: "Are you sure you want to delete this One Time Task?",
  delete: "Delete",
  addRoutineTask: "Add One Time Task",
  taskName: "Task Name*",
  description: "Description",
  assignTo: "Assign To*",
  supervisor: "Supervisor",
  informer: "Informer",
  consultant: "Consultant",
  editOneTimeTask: "Edit One Time Task",
  update: "Update",
  close: "Close",
  create: "Create",
  oneTimeTasks: "One Time Tasks",
  TaskNameRequired: "Please enter the task name.",
  TaskAddedError:
    "An error occurred while adding the task. Please try again later.",
  from: "From",
  to: "To",
  TaskManager: "Task Manager",
  assignManager: "Assign Manager",
  enterDescription: "Enter Description",
  selectProject: "Select Project",
  selectDepartment: "Select Department",
  enterTaskName: "Enter Task Name",
  createOneTimeTask: "Create One Time Task",
  saving: "Saving...",
  noRoutineTasks: "No one-time tasks found.",
  createee: "Create your one-time tasks",
  inactive: "Inactive",
  active: "Active",
  advancedSettings: "Advanced Settings",
  taskNumber: "Task Number",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  enterStartDate: "Enter start date",
  startDate: "Start Date*",
  endDate: "End Date",
  taskType: "Task Type",
  status: "Status",
  department: "Department",
  allTypes: "All Types",
  allStatuses: "All Status",
  allDepartments: "All Departments",
  weekly: "Weekly",
  monthly: "Monthly",
  daily: "Daily",
  applyFilters: "Apply Filters",
  resetFilters: "Reset Filters",
  selectAll: "Select All",
  departmentsSelected: "Departments Selected",
  done: "Done",
  not_done: "Not Done",
  inProgress: "In Progress",
  pending: "Pending",
  review: "Review",
  allPriorities: "All Priorities",
  allEmployees: "All Employees",
  allDeadLines: "All DeadLines",
  deadLine: "DeadLine",
  high: "High",
  normal: "Normal",
  low: "Low",
  urgent: "Urgent",
  overDue: "Overdue",
  soon: "Soon within 2 days",
  noDueDate: "No Due Date",
  hasNewUpdate: "Has New Update",
  not_reported: "Not Reported",
  LatedTasks: "Lated Tasks",
  allProjects: "All Projects",
  project: "Project",
  isUrgent: "Is Urgent",
  priority: "Priority",
  employee: "Employee",
  searchPlaceholder: "Search tasks by Task Name, Employee ...",
  selectEmployee: "Select Employee",
  selectSupervisor: "Select Supervisor",
  selectAssignee: "Select Assignee",
  selectConsultant: "Select Consultant",
  selectInformer: "Select Informer",
  searchEmployees: "Search Employees",
  searchInformers: "Search Informers",
  searchConsultants: "Search Consultants",
  searchProjects: "Search Projects",
  searchPriorities: "Search Priorities",
  selectStartDate: "Select Start Date",
  selectEndDate: "Select End Date",
  selectPriority: "Select Priority",
  noResultsFound: "No results found",
  clickToAddPeople: "Click to add Employees",
  undo: "Undo",
  redo: "Redo",
  bold: "Bold",
  italic: "Italic",
  underline: "Underline",
  alignLeft: "Align Left",
  alignCenter: "Align Center",
  alignRight: "Align Right",
  bulletList: "Bullet List",
  numberedList: "Numbered List",
  link: "Insert Link",
  image: "Insert Image",
  moreOptions: "More Options",
  // Missing keys from usage
  errorOccurred: "An error occurred",
  projectsSelected: "Projects Selected",
  clickToEdit: "Click to edit",
  enterEndDate: "Enter end date",
  searchEmployee: "Search Employee",
  // OneTimeTaskTable.vue translations
  tasksTable: "Tasks Table",
  noTasksHere: "No tasks found here.",
  comment: "comment",
  reply: "Reply",
  cancel: "Cancel",
  submit: "Submit",
  log: "Log",
  info: "Info",
  assignedTo: "Assigned To",
  createdBy: "Created By",
  supervisorAccountable: "Accountable", // Used in OneTimeTaskTable.vue
  noLogsAvailable: "No logs available",
  deleteConfirmationSuccess: "Task deleted successfully.",
  reportTaskType: "Report Task Type",
  selectReportTaskType: "Select Report Task Type",
  taskFound: "There is task?",
  selectTaskFound: "Select Task Found",
  errorUpdatingTask: "Error updating task",
  errorUpdatingStatus: "Error updating task status",
  taskReportedSuccessfully: "Task reported successfully",
  editTask: "Edit Task",
  comment_text: "Comment",
  write_comment: "Write a comment",
  writeComment: "Write your comment here...",
  upload: "Upload",
  submitting: "Submitting...",
  uploading: "Uploading...",
  changedTheField: "changed the field",
  onDate: "On",
  noTasks: "No tasks found",
  createdAt: "Created At",
  assignedUser: "Assigned User",
  fromTime: "From Time",
  dayOfWeek: "Day of Week",
  tasks: "Tasks",
  taskReportedSuccessfullyMessage: "Task reported successfully",
  yes: "Yes",
  no: "No",
  deadline: "Deadline",
  rework: "Rework",
  taskStatusUpdated: "Task status updated",
  success: "Success",
  archive: "Archive",
  restore: "Restore",
  taskArchivedSuccessfully: "Task archived successfully",
  taskRestoredSuccessfully: "Task restored successfully",
  edit: "Edit",
  uploadError: "Upload Error",
  fileSizeExceedsLimit: "The file size exceeds the allowed limit of {size}.",
  maxFileSize: "Max file size: {size}",
  consult: "Consult",
  // Tab names
  inbox: "Inbox",
  own: "Own",
  started: "Started",
};
